import React from 'react'
import { usePutRequest } from '../../hooks/request'
import { ANIMAL_RECORD_DETAIL } from '../../urls'
import { useMessage } from '../../hooks/message'
import { AnimalRecordForm } from './AnimalRecordForm'

export default function AnimalRecordUpdate({ onCancel, onSuccess, item }) {
    const recordUpdate = usePutRequest({ url: ANIMAL_RECORD_DETAIL.replace('{id}', item.id) })
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        const formData = new FormData()

        // Add record fields
        if (data.weight) {
            formData.append('weight', data.weight)
        }

        if (data.health_status) {
            formData.append('health_status', data.health_status)
        }

        if (data.notes) {
            formData.append('notes', data.notes)
        }

        if (data.record_date) {
            formData.append('record_date', data.record_date)
        }

        // Add new images only
        if (data.newImages && data.newImages.length > 0) {
            data.newImages.forEach((image) => {
                if (image instanceof File) {
                    formData.append('images', image)
                }
            })
        }

        const { success } = await recordUpdate.request({ data: formData })

        if (success) {
            showMessage('Ёзув муваффақиятли ўзгартирилди', 'is-success')
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Ёзувни ўзгартириш</b>
            </h1>
            <AnimalRecordForm
                loading={recordUpdate.loading}
                initialValues={item}
                onSubmit={onSubmit}
                onCancel={onCancel}
            />
        </div>
    )
}
